import { SupportTicketDetail } from "src/api/rtk/indorsoftRu/slices/supportApiSlice";
import { formatBitrixMoscowToUserDateTime } from "src/shared/format/date";
import css from "../SupportTicketPage.module.scss";

type TicketSummaryProps = {
    ticket: SupportTicketDetail;
};

export default function TicketSummary({ ticket }: TicketSummaryProps) {
    return (
        <section className={css.ticketSummary}>
            <h2 className={css.ticketTitle}>{ticket.TITLE}</h2>
            <div className={css.ticketMeta}>
                <div>
                    <span className={css.metaLabel}>Создано:</span>
                    <span className={css.metaValue}>
                        {formatBitrixMoscowToUserDateTime(ticket.DATE_CREATE)}
                    </span>
                </div>
                <div>
                    <span className={css.metaLabel}>Обновлено:</span>
                    <span className={css.metaValue}>
                        {formatBitrixMoscowToUserDateTime(ticket.TIMESTAMP_X)}
                    </span>
                </div>
                {ticket.STATUS_NAME && (
                    <div>
                        <span className={css.metaLabel}>Статус:</span>
                        <span className={css.metaValue}>{ticket.STATUS_NAME}</span>
                    </div>
                )}
                {ticket.CRITICALITY_NAME && (
                    <div>
                        <span className={css.metaLabel}>Критичность:</span>
                        <span className={css.metaValue}>
                            {ticket.CRITICALITY_NAME}
                        </span>
                    </div>
                )}
                {ticket.CATEGORY_NAME && (
                    <div>
                        <span className={css.metaLabel}>Категория:</span>
                        <span className={css.metaValue}>{ticket.CATEGORY_NAME}</span>
                    </div>
                )}
            </div>
        </section>
    );
}

